export const typography = {
  fontFamily: '"Inter",sans-serif',
  h1: {
    fontFamily: 'NBInternationalProReg,sans-serif',
    fontSize: '1.70rem'
  },
  h2: {
    fontFamily: 'NBInternationalProReg,sans-serif',
    letterSpacing: '0.01em',
    fontSize: '1.5rem'
  },
  h3: {
    fontFamily: 'NBInternationalProReg,sans-serif'
  },
  h4: {
    fontFamily: 'NBInternationalProReg,sans-serif'
  },
  h5: {
    fontFamily: 'NBInternationalProReg,sans-serif'
  },
  h6: {
    fontFamily: 'NBInternationalProReg,sans-serif'
  }
}
